import React from 'react';

function getDefaultStateReducer<T extends { [key: string]: any }>() {
  return (state: T, action: { field: keyof T; value: any }) => {
    return { ...state, [action.field]: action.value };
  };
}
function getDefaultReducerChange<T extends { [key: string]: any }>(dispatch) {
  return React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    let value: number | string = e.target.value;
    if (e.target.type === 'number') {
      value = parseFloat(value);
    }
    dispatch({
      field: e.target.name as keyof T,
      value,
    });
  }, []);
}
export { getDefaultStateReducer, getDefaultReducerChange };
